import React, { useEffect, useState } from 'react'; // (1) استيراد useState
import { useForm, SubmitHandler } from 'react-hook-form';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { getUserById, updateUser, UpdateUserData } from '../../../services/userService';
import { UserRole, UserStatus } from '../../../types/user';
import formStyles from '../trainees/TraineeForm.module.css';

// هذا النوع يبقى كما هو، لأنه يمثل البيانات التي يمكن إرسالها للتحديث
type FormInputs = Required<UpdateUserData> & { phone: string };

const EditUserPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const userId = Number(id);

  // (2) إنشاء حالة لتخزين البريد الإلكتروني بشكل منفصل
  const [userEmail, setUserEmail] = useState<string>('');

  const { 
    register, 
    handleSubmit, 
    reset, 
    // لم نعد بحاجة إلى watch هنا
    formState: { errors, isSubmitting } 
  } = useForm<FormInputs>();

  // (3) إزالة السطر الذي يسبب الخطأ
  // const userEmail = watch('email'); // <-- هذا السطر تم حذفه

  useEffect(() => {
    if (!userId) return;
    const fetchUserData = async () => {
      try {
        const userData = await getUserById(userId);
        
        // (4) تعبئة النموذج بالبيانات القابلة للتعديل
        reset({
          phone: userData.phone,
          role: userData.role,
          status: userData.status,
        });

        // (5) تحديث حالة البريد الإلكتروني لعرضها في العنوان
        setUserEmail(userData.email);

      } catch (error) {
        toast.error('فشل في جلب بيانات المستخدم.');
        navigate('/admin/users/list');
      }
    };
    fetchUserData();
  }, [userId, navigate, reset]);

  const onSubmit: SubmitHandler<FormInputs> = (data) => {
    const promise = updateUser(userId, data);
    toast.promise(promise, {
      loading: 'جاري تحديث البيانات...',
      success: () => {
        navigate('/admin/users/list');
        return 'تم تحديث بيانات المستخدم بنجاح!';
      },
      error: (err) => err.response?.data?.message || 'فشل في تحديث البيانات.',
    });
  };

  return (
    <div className={formStyles.pageContainer}>
      <div className={formStyles.formContainer}>
        {/* (6) العنوان سيستخدم الآن الحالة 'userEmail' */}
        <h2 className={formStyles.title}>تعديل المستخدم: {userEmail}</h2>
        <form onSubmit={handleSubmit(onSubmit)} className={formStyles.form}>
          
          {/* باقي حقول النموذج تبقى كما هي */}
          <div className={formStyles.formField}>
            <label htmlFor="phone" className={formStyles.label}>رقم الهاتف</label>
            <input id="phone" type="tel" {...register('phone', { required: 'رقم الهاتف مطلوب' })} className={formStyles.input} />
            {errors.phone && <p className={formStyles.error}>{errors.phone.message}</p>}
          </div>

          <div className={formStyles.formField}>
            <label htmlFor="role" className={formStyles.label}>دور المستخدم</label>
            <select id="role" {...register('role', { required: 'الدور مطلوب' })} className={formStyles.input}>
              {Object.values(UserRole).map(role => (
                <option key={role} value={role}>{role}</option>
              ))}
            </select>
            {errors.role && <p className={formStyles.error}>{errors.role.message}</p>}
          </div>

          <div className={formStyles.formField}>
            <label htmlFor="status" className={formStyles.label}>حالة الحساب</label>
            <select id="status" {...register('status', { required: 'الحالة مطلوبة' })} className={formStyles.input}>
              {Object.values(UserStatus).map(status => (
                <option key={status} value={status}>{status}</option>
              ))}
            </select>
            {errors.status && <p className={formStyles.error}>{errors.status.message}</p>}
          </div>

          <div className={`${formStyles.buttonContainer} ${formStyles.fullWidth}`}>
            <Link to="/admin/users/list" className={formStyles.cancelButton}>إلغاء</Link>
            <button type="submit" disabled={isSubmitting} className={formStyles.submitButton}>
              {isSubmitting ? 'جاري الحفظ...' : 'حفظ التعديلات'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditUserPage;
